import * as trajectoryUtil from "core/src/core/geometry/trajectory/trajectory-util.js";
import { wormColors } from "core/src/core/constants.js";
import ScaledCanvasContext from "../scaled-canvas-context.js";

// DEBUG overlay. Draws a hollow ring where the SERVER has each worm's head at
// server-now (no render delay), on top of the normal head canvas. So for every
// worm you can see the gap between what you render (opponents delayed by
// RENDER_DELAY; your own worm predicted in real time) and the authoritative
// server truth. This is how you catch death-in-the-open (#3), head-on weirdness
// (#7) and — the mystery — your own worm "lagging back" (#2): if your bright
// predicted head separates from its own ghost ring, the client is being
// overruled/adjusted somewhere it shouldn't be.
//
// It reads remote-game's captured server segments (which include your own worm,
// otherwise discarded), follows each at getTime() (= getServerTime, no delay),
// and strokes a ring. Runs only when RemoteGame passes `serverGhost` (the
// `?ghost=1` flag), so normal play never pays for it. Pushed after the head
// renderers, and the head renderer clears this canvas each frame, so no smear.
export default function ServerGhostRenderer({ gameState, players, getSegment, getTime, canvas, canvasState, scale = 1 }) {
    var context = canvas.getContext("2d");
    var scaled = ScaledCanvasContext(context, scale);

    function render() {
        // Debug-only rings all over the arena: keep the shared dynamic layer in
        // full-clear mode while this overlay is active (see worm-body-renderer).
        if (canvasState && canvasState.dyn) canvasState.dyn.full = true;
        var t = getTime();
        players.forEach(function (player) {
            var seg = getSegment(player.id);
            if (!seg) return;
            var worm = gameState.worms.find(function (w) { return w.playerId === player.id; });
            var end = (seg.endTime != null) ? seg.endTime : (seg.startTime + seg.duration);
            var pt = Math.min(t, end);
            var pos = trajectoryUtil.followTrajectory(seg, pt - seg.startTime);
            if (!pos || !isFinite(pos.x) || !isFinite(pos.y)) return;

            context.save();
            context.strokeStyle = wormColors[player.colorId] || "#ffffff";
            // Dim a worm the server considers dead; bright while it's alive.
            context.globalAlpha = worm && worm.alive === false ? 0.3 : 0.85;
            context.setLineDash([scale * 3, scale * 3]); // dashed = "this is the ghost, not the real head"
            context.lineWidth = scale * 2;
            context.beginPath();
            scaled.arc(pos.x, pos.y, (seg.size || 3) + 3, 0, 2 * Math.PI);
            context.stroke();
            // A short tick pointing along travel direction, so heading is visible too.
            context.setLineDash([]);
            context.beginPath();
            scaled.moveTo(pos.x, pos.y);
            scaled.lineTo(pos.x + Math.cos(pos.direction) * (seg.size + 9), pos.y + Math.sin(pos.direction) * (seg.size + 9));
            context.stroke();
            context.restore();
        });
    }

    return { render: render };
}
